// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
Define CSS variables for light and dark modes.

This stylesheet is imported into both the Gym webapp and the Remedy player app
(the thing that is embedded in a webview on iOS/Android/Mac/etc). Therefore
you must be careful to namespace things to avoid conflicts with the Gym.

The remedy player app's \`index.html\` also defines document-level color styles.
See that file for more explanation. It is your responsibility to keep them in-sync.
*/

:root {
    --pl-remedy-bg-color: white;
    --pl-remedy-text-color: #222;
    --pl-remedy-accent-color: #0072C6;
}

@media (prefers-color-scheme: dark) {
    :root {
        --pl-remedy-bg-color: black;
        --pl-remedy-text-color: white;
        --pl-remedy-accent-color: #008ff8;
    }
}

#remedy-container {
    background: var(--pl-remedy-bg-color); /* also see remedy player \`index.html\` */
    color: var(--pl-remedy-text-color);    /* also see remedy player \`index.html\` */
    font-family: -apple-system, BlinkMacSystemFont, "Roboto",
    "Helvetica Neue", sans-serif;
    font-size: 14px;
    max-width: 300px;
    margin-top: 42px;
    margin-left: auto;
    margin-right: auto;
}

#remedy-container a,
#remedy-container a:link,
#remedy-container a:visited,
#remedy-container a:hover {
    color: var(--pl-remedy-accent-color);
    text-decoration: none;
}

#remedy-container h1 {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
}

#remedy-container p {
    font-size: 14px;
}

#remedy-container li {
    margin-bottom: 16px;
}

#remedy-container img {
    max-width: 260px;
}

/* buttons */

#remedy-container .btn-big {
    color: var(--pl-remedy-accent-color);
    display: block;
    background: var(--pl-remedy-bg-color);
    border:1px solid var(--pl-remedy-accent-color);
    border-radius: 3px;
    width: 100%;
    max-width: 300px;
    height: 44px;
    margin: 20px auto;
    font-weight: bold;
    font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./assets/remedy-player.css"],"names":[],"mappings":"AAAA;;;;;;;;;CASC;;AAED;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,iCAAiC;AACrC;;AAEA;IACI;QACI,2BAA2B;QAC3B,6BAA6B;QAC7B,iCAAiC;IACrC;AACJ;;AAEA;IACI,qCAAqC,EAAE,wCAAwC;IAC/E,kCAAkC,KAAK,wCAAwC;IAC/E;gCAC4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;;IAII,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,YAAY;;AAEZ;IACI,oCAAoC;IACpC,cAAc;IACd,qCAAqC;IACrC,8CAA8C;IAC9C,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":["/**\nDefine CSS variables for light and dark modes.\n\nThis stylesheet is imported into both the Gym webapp and the Remedy player app\n(the thing that is embedded in a webview on iOS/Android/Mac/etc). Therefore\nyou must be careful to namespace things to avoid conflicts with the Gym.\n\nThe remedy player app's `index.html` also defines document-level color styles.\nSee that file for more explanation. It is your responsibility to keep them in-sync.\n*/\n\n:root {\n    --pl-remedy-bg-color: white;\n    --pl-remedy-text-color: #222;\n    --pl-remedy-accent-color: #0072C6;\n}\n\n@media (prefers-color-scheme: dark) {\n    :root {\n        --pl-remedy-bg-color: black;\n        --pl-remedy-text-color: white;\n        --pl-remedy-accent-color: #008ff8;\n    }\n}\n\n#remedy-container {\n    background: var(--pl-remedy-bg-color); /* also see remedy player `index.html` */\n    color: var(--pl-remedy-text-color);    /* also see remedy player `index.html` */\n    font-family: -apple-system, BlinkMacSystemFont, \"Roboto\",\n    \"Helvetica Neue\", sans-serif;\n    font-size: 14px;\n    max-width: 300px;\n    margin-top: 42px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n#remedy-container a,\n#remedy-container a:link,\n#remedy-container a:visited,\n#remedy-container a:hover {\n    color: var(--pl-remedy-accent-color);\n    text-decoration: none;\n}\n\n#remedy-container h1 {\n    font-size: 20px;\n    font-weight: bold;\n    text-align: center;\n}\n\n#remedy-container p {\n    font-size: 14px;\n}\n\n#remedy-container li {\n    margin-bottom: 16px;\n}\n\n#remedy-container img {\n    max-width: 260px;\n}\n\n/* buttons */\n\n#remedy-container .btn-big {\n    color: var(--pl-remedy-accent-color);\n    display: block;\n    background: var(--pl-remedy-bg-color);\n    border:1px solid var(--pl-remedy-accent-color);\n    border-radius: 3px;\n    width: 100%;\n    max-width: 300px;\n    height: 44px;\n    margin: 20px auto;\n    font-weight: bold;\n    font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
